import React, { useState, useEffect } from "react"
import { useParams, Link } from "react-router-dom"
import Loader from "../../components/Loader"

// custom hook
import useGetPlots from "../../hooks/useGetPlot"

export default function State() {
  const { id } = useParams()
  const [windowWidth, setWindowWidth] = useState(window.innerWidth || null)
  const [viewPort, setViewPort] = useState(null)

  useEffect(() => {
    window &&
      window.addEventListener("resize", () => setWindowWidth(window.innerWidth))
    if (windowWidth >= 320) {
      setViewPort("small")
    }
    if (windowWidth >= 780) {
      setViewPort("medium")
    }
    if (windowWidth >= 1024) {
      setViewPort("large")
    }
  }, [windowWidth])

  const [err, loading, displayPlot, usStateData] = useGetPlots(
    "state",
    viewPort,
    id
  )

  if (loading) return <Loader />

  return (
    <div className="page-state">
      <div className="container">
        <h1>{usStateData.name}</h1>
        <Link to="/" className="btn back-home">
          Return to State Impact Map
        </Link>
        <h2>
          Shatterproof is leading a national coalition of partners, in
          partnership with the Johns Hopkins University Bloomberg School of
          Public Health, to enact guiding principles to place guardrails on the
          use of opioid litigation funds across the country.
        </h2>
        <p>
          Many states and localities will be tempted to use the dollars to fill
          holes in their budgets rather than expand needed programs.
          Jurisdictions should use the funds to supplement rather than replace
          existing spending.
        </p>

        <hr />
        <h3>{usStateData.name}: Total Distributions by Settlement Fund</h3>
        <p>
          While prescription opioid dispensing rates may be declining in U.S.
          states, the age-adjusted drug death rates (per 100,000 population) has
          not been affected and, in many cases, is experiencing an increase due
          to the COVID-19 pandemic and the rise in the use of fentanyl/synthetic
          opioids. Overall, these key rate trendlines demonstrate the need to
          ensure settlement funds are flowing directly to needed treatment and
          recovery support services within states.{" "}
        </p>
        {displayPlot("donut")}
        <hr />
        <h3>{usStateData.name}: Opioid-Related Key Indicator Rate Trends</h3>
        <p>
          While prescription opioid dispensing rates may be dramatically
          declining in U.S. states, opioid-related drug overdose death rates
          (per 100,000 persons) have not been affected and, in many cases, are
          experiencing an increase due to the COVID-19 pandemic and the rise in
          the use of synthetic opioids including fentanyl. Overall, these key
          rate trends demonstrate the need to ensure opioid settlement funds are
          flowing directly to needed treatment and recovery support services
          within states.
        </p>
        {displayPlot("bar")}
        <small style={{ display: "block", marginTop: 30 }}>
          <strong>Source:</strong> SAMHSA, Center for Behavioral Health
          Statistics and Quality, National Survey on Drug Use and Health,
          Quarters 1 and 4, 2020, 2019-2020 National Survey On Drug Use And
          Health: Model-Based Prevalence Estimates. Retrieved from:
          https://www.samhsa.gov/data/report/2019-2020-nsduh-state-prevalence-estimates;
          Centers for Disease Control and Prevention (CDC), National Center for
          Health Statistics. Multiple Cause of Death 1999-2019 on CDC WONDER
          Online Database, released 2021. Retrieved from: http://wonder.cdc.gov
        </small>
      </div>
    </div>
  )
}
